import React from 'react';
import { IStyleProps, LottieAnimation } from '../LottieAnimation';
import bag from './bag.json';

export const LottieBag: React.FC<IStyleProps> = (props) => <LottieAnimation animationData={bag} {...props} />;
